module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "slay.f29da73e.jpg";